/**
 * Stage 1A — new packaged-snack pattern (create only).
 * Packet (each, 1) = stock + count + sales unit; Case (each, N) = purchase
 * unit with case_qty = case_size = N. No grams, servings or yield assumed.
 */
import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Package } from 'lucide-react';

const BASE_UNIT = {
  unit_type: '', base_unit: 'each', conversion_to_base: '',
  is_base_stock_unit: false, is_default_count_unit: false, is_default_purchase_unit: false,
  is_sales_unit: false, is_default_sales_unit: false,
  waste_factor: '', observed_servings_per_unit: '', net_grams: '', net_grams_evidence: '',
};

export function packetPatternUnits(n) {
  return [
    { ...BASE_UNIT, unit_type: 'Packet', conversion_to_base: '1',
      is_base_stock_unit: true, is_default_count_unit: true, is_sales_unit: true, is_default_sales_unit: true },
    { ...BASE_UNIT, unit_type: 'case', conversion_to_base: String(n),
      is_default_purchase_unit: true, case_qty: n, _units_per_case: String(n) },
  ];
}

export function PacketPatternHelper({ setForm }) {
  const [perCase, setPerCase] = useState('');
  const n = parseInt(perCase, 10);
  const valid = Number.isInteger(n) && n > 0;
  return (
    <div className="flex flex-wrap items-end gap-3 rounded-lg border border-dashed border-sky-300 bg-white px-3 py-2.5" data-testid="packet-pattern-helper">
      <div className="flex items-center gap-1.5 text-xs text-slate-700 min-w-[180px]">
        <Package className="h-3.5 w-3.5 text-sky-600" />
        <span><strong>Packaged snack?</strong> Packet counted &amp; sold, bought by the case.</span>
      </div>
      <div className="space-y-1">
        <label className="text-[11px] font-medium text-slate-600" htmlFor="packet-pattern-per-case">Packets per case</label>
        <Input id="packet-pattern-per-case" type="number" min="1" step="1" className="h-8 w-24 text-xs"
          value={perCase} onChange={(e) => setPerCase(e.target.value)} placeholder="e.g. 24"
          data-testid="packet-pattern-per-case" />
      </div>
      <Button type="button" size="sm" variant="outline" className="h-8 text-xs" disabled={!valid}
        onClick={() => setForm(f => ({ ...f, case_size: String(n), units: packetPatternUnits(n) }))}
        data-testid="packet-pattern-apply">
        Use packet + case units
      </Button>
    </div>
  );
}
